
export default {
  props: {
    video: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      popup: false,
    };
  },

  methods: {
    togglePopup() {
      this.popup = !this.popup;

      if (this.popup) {
        document.body.style.height = "100vh";
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.height = "unset";
        document.body.style.overflow = "unset";
      }
    },
  },
};
